var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTraductionIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,0A20,20,0,1,1,0,20,20,20,0,0,1,20,0",
    fill: "#2699fb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,16.779a1.236,1.236,0,0,0,1.658-.553l.276-.553h4.65l.276.553a1.262,1.262,0,0,0,1.658.553,1.237,1.237,0,0,0,.553-1.658h0L13.365,7.708a1.286,1.286,0,0,0-2.21,0L7.449,15.121A1.234,1.234,0,0,0,8,16.778H8m4.259-5.756,1.09,2.18H11.17Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.791,28.028a1.236,1.236,0,0,0,0-2.471H28.32V24.322a1.235,1.235,0,1,0-2.471,0v1.235H23.378a1.236,1.236,0,0,0,0,2.471h3.195L22.5,32.1a1.235,1.235,0,0,0,0,1.746h0a1.251,1.251,0,0,0,1.747,0l2.833-2.833,2.833,2.833a1.253,1.253,0,0,0,1.746,0,1.234,1.234,0,0,0,0-1.746h0l-2.832-2.833,1.235-1.235Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.174,10.732H23.891l1.6-1.6a1.235,1.235,0,0,0-1.747-1.747l-3.7,3.705a1.251,1.251,0,0,0,0,1.749l3.7,3.705a1.257,1.257,0,0,0,1.747,0,1.235,1.235,0,0,0,0-1.746h0l-1.6-1.6h6.283a.619.619,0,0,1,.618.618v6.794a1.236,1.236,0,1,0,2.471,0V13.821a3.093,3.093,0,0,0-3.089-3.089",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.574,28.792a1.171,1.171,0,0,0-.266-.4l-3.7-3.706A1.236,1.236,0,0,0,13.826,26.4l.031.032,1.6,1.6H9.171a.621.621,0,0,1-.618-.618v-6.8a1.236,1.236,0,1,0-2.471,0v6.8A3.091,3.091,0,0,0,9.171,30.5h6.283l-1.6,1.6a1.234,1.234,0,0,0,0,1.747,1.257,1.257,0,0,0,1.747,0l3.7-3.7a1.262,1.262,0,0,0,.265-1.347",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraductionIcon);
export default __webpack_public_path__ + "static/media/traduction-icon.67823ce0f84d145e5d618467c918989d.svg";
export { ForwardRef as ReactComponent };